import context from "./context.js"
import App from './app/App.svelte';

const app = new App({
	target: document.body,
	props: {
		ctx : context
	}
});

export default app;